import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface DocumentContentType {
  name: string
  description: string
  additional_notes: string
  text: string
  article_id: string
  core_functionalities: []
  userId: string
}


interface DocumentationState {
  documentationContent: DocumentContentType;
  selectedDocumentSteps: string[]
  currentDocumentationSteps: number
  openCreateDocumentation: boolean
}

const initialState: DocumentationState = {
  documentationContent: {
    name: "",
    description: "",
    additional_notes: "",
    text: "",
    article_id: "",
    core_functionalities: [],
    userId: ""
  },
  selectedDocumentSteps: ["modeSelection"],
  currentDocumentationSteps: 0,
  openCreateDocumentation: false
};

// Create the slice
const documentationSlice = createSlice({
  name: "documentation",
  initialState,
  reducers: {
    setDocumentationContent(state, action: PayloadAction<DocumentContentType>) {
      state.documentationContent = action.payload;
    },
    setSelectedDocumentSteps(state, action: PayloadAction<string[]>) {
      state.selectedDocumentSteps = action.payload;
    },
    setCurrentDocumentationSteps(state, action: PayloadAction<any>) {
      state.currentDocumentationSteps = action.payload;
    },
    setOpenCreateDocumentation(state, action: PayloadAction<boolean>) {
      state.openCreateDocumentation = action.payload;
    },
    incrementDocumentationStep(state) {
      state.currentDocumentationSteps += 1;
    },
    decrementDocumentationStep(state) {
      state.currentDocumentationSteps -= 1;
    },
    resetDocumentationState(state) {
      state.documentationContent = {
        name: "",
        description: "",
        additional_notes: "",
        text: "",
        article_id: "",
        core_functionalities: [],
        userId: ""
      };
      state.selectedDocumentSteps = ["modeSelection"];
    },

  },
});

// Export the actions
export const {
  setDocumentationContent,
  setSelectedDocumentSteps,
  resetDocumentationState,
  setCurrentDocumentationSteps,
  incrementDocumentationStep,
  decrementDocumentationStep,
  setOpenCreateDocumentation
} = documentationSlice.actions;

// Export the reducer
export default documentationSlice.reducer;